import React, { useRef } from 'react';
import { observer } from 'mobx-react';

import { DateType } from 'shared/types';
import { toDate } from 'shared/utilities';
import { UiCalendar } from 'shared/uikit-new';

import { Store } from 'pages/calendar/store';

import { CalendarPageYearMonthDay } from './components/CalendarPageYearMonthDay';

import './styles.scss';

type PropsType = {
    date: DateType;
};

export const CalendarPageYearMonth = observer(function CalendarPageYearMonth({ date }: PropsType) {
    const ref=useRef<HTMLDivElement>(null);

    const calendarItemsDates = Store.calendarItems.map(calendarItem => toDate(calendarItem.startAt).format('YYYY-MM-DD'));

    return (
        <div ref={ref} className='calendar-page-year-month'>
            <UiCalendar
                key={date.format()}
                slots={{
                    header: () => (
                        <div
                            className='calendar-page-year-month__header'
                            onClick={() => {
                                Store.update({
                                    date: date.startOf('month'),
                                    view: 'month',
                                });
                            }}
                        >
                            {date.format('MMMM')}
                        </div>
                    ),
                    day: ({ className, onClick, date, isOuter }) => (
                        <CalendarPageYearMonthDay key={date.format()} className={className} date={date} isOuter={isOuter}/>
                    ),
                }}
                defaultValue={date.format()}
                value={null}
                items={calendarItemsDates}
            />
        </div>
    );
});
